import { render, staticRenderFns } from "./DashboardIncidenceWidget.vue?vue&type=template&id=36d07c22&scoped=true"
import script from "./DashboardIncidenceWidget.vue?vue&type=script&lang=js"
export * from "./DashboardIncidenceWidget.vue?vue&type=script&lang=js"
import style0 from "./DashboardIncidenceWidget.vue?vue&type=style&index=0&id=36d07c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d07c22",
  null
  
)

export default component.exports